import pluralize from "pluralize";
import {PropsWithChildren, useContext} from "react";

import {ButtonWithMutationAndConfirmationDialog} from "@/components/ButtonWithMutationAndConfirmationDialog/ButtonWithMutationAndConfirmationDialog.tsx";
import {
  GQL_DELETE_SUBSCRIPTION_EMAIL_DOMAINS,
  GQL_SUBSCRIPTION_EMAIL_DOMAINS,
  GQL_SUBSCRIPTION_EMAIL_DOMAINS_COUNTS,
} from "@/lib/queries/statuspages.ts";
import {SubscriptionEmailDomainType} from "@/lib/types/statuspages.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";

export interface DeleteEmailDomainsActionButtonProps extends PropsWithChildren {
  domainIds: number[];
  domainType: SubscriptionEmailDomainType;
  isBulkAction?: boolean;
  onSuccess: () => void;
  variant: "tableRow" | "tableCrown";
}

export const DeleteEmailDomainsActionButton = ({
  domainIds,
  isBulkAction,
  domainType,
  children,
  onSuccess,
  variant,
}: DeleteEmailDomainsActionButtonProps) => {
  const {statusPage} = useContext(StatusPageContext);
  return (
    <ButtonWithMutationAndConfirmationDialog
      dialogTitle={`Delete ${domainType === SubscriptionEmailDomainType.ALLOWED ? "Allowed" : "Blocked"} Email ${pluralize("Domain", domainIds.length)}`}
      dialogElement={
        <p>
          Are you sure you want to delete the {isBulkAction ? "selected" : ""}{" "}
          {domainType === "ALLOWED" ? "Allowed" : "Blocked"} Email {pluralize("Domain", domainIds.length)}?
        </p>
      }
      mutation_hook_options={{
        refetchQueries: [
          GQL_SUBSCRIPTION_EMAIL_DOMAINS_COUNTS,
          {
            query: GQL_SUBSCRIPTION_EMAIL_DOMAINS,
            variables: {statusPageID: statusPage.id, emailDomainType: SubscriptionEmailDomainType.BLOCKED, query: ""},
          },
          {
            query: GQL_SUBSCRIPTION_EMAIL_DOMAINS,
            variables: {statusPageID: statusPage.id, emailDomainType: SubscriptionEmailDomainType.ALLOWED, query: ""},
          },
        ],
      }}
      mutation_GQL={GQL_DELETE_SUBSCRIPTION_EMAIL_DOMAINS}
      mutation_variables={{statusPageID: statusPage.id, domainIds: domainIds}}
      postMutationAction={() => onSuccess()}
      variant={variant}
      tooltip={false}
    >
      {children}
    </ButtonWithMutationAndConfirmationDialog>
  );
};
